import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Module } from './module';

@Injectable({
  providedIn: 'root'
})
export class ModulesService {
  items = [];

  constructor(private httpClient: HttpClient) {}

  getModules() {
    return this.httpClient.get<Module[]>('/assets/modules.json');
  }
}
